import { useGetCompanyVendorsQuery } from "marketplace/companies/_api/company-api";
import { getCompanyVendors } from "marketplace/companies/_store/companies-redux-slice";
import Company from "marketplace/companies/company";
import { useGetIndividualVendorsQuery } from "marketplace/individuals/_api/individual-api";
import { getIndividualVendors } from "marketplace/individuals/_stores/individuals-redux-slice";
import Individual from "marketplace/individuals/individual";
import { ProfileTableData } from "marketplace/_views/profiles/profile-table-data";
import { useGetTeamVendorsQuery } from "marketplace/teams/_api/marketplace-team-api";
import { getTeamVendors } from "marketplace/teams/_store/marketplace-teams-redux-slice";
import Team from "marketplace/teams/team";
import { useSelector } from "react-redux";

export type MarketplaceProfileStore = {
  companyProfiles?: Company[];
  individualProfiles?: Individual[];
  isError: boolean;
  isLoading: boolean;
  profiles: ProfileTableData[];
  /** Runs the query again, for the table's own retry when it failed and left nothing on screen. */
  refetch: () => void;
  showSkeletons: boolean;
  teamProfiles?: Team[];
};

export function useIndividualProfileStore(): MarketplaceProfileStore {
  const individualProfiles = useSelector(getIndividualVendors());
  const individualQuery = useGetIndividualVendorsQuery();

  return {
    individualProfiles,
    isError: individualQuery.isError,
    isLoading: individualQuery.isLoading,
    profiles: individualProfiles ?? [],
    refetch: () => void individualQuery.refetch(),
    showSkeletons: individualQuery.isLoading && !individualProfiles,
  };
}

export function useCompanyProfileStore(): MarketplaceProfileStore {
  const companyProfiles = useSelector(getCompanyVendors());
  const companyQuery = useGetCompanyVendorsQuery();

  return {
    companyProfiles,
    isError: companyQuery.isError,
    isLoading: companyQuery.isLoading,
    profiles: companyProfiles ?? [],
    refetch: () => void companyQuery.refetch(),
    showSkeletons: companyQuery.isLoading && !companyProfiles,
  };
}

export function useTeamProfileStore(): MarketplaceProfileStore {
  const individualProfiles = useSelector(getIndividualVendors());
  useGetIndividualVendorsQuery();
  const teamProfiles = useSelector(getTeamVendors());
  const teamQuery = useGetTeamVendorsQuery();

  return {
    individualProfiles,
    isError: teamQuery.isError,
    isLoading: teamQuery.isLoading,
    profiles: teamProfiles ?? [],
    refetch: () => void teamQuery.refetch(),
    showSkeletons: teamQuery.isLoading && !teamProfiles,
    teamProfiles,
  };
}
